import { ArrowLeft, Sparkles } from "lucide-react";
import { dictionary, Language } from "@/utils/dictionary";
import { useAuth } from "@/context/AuthContext";
import { DefaultButton } from "@/components/buttons/DefaultButton";

interface FunnelCreativesHeaderProps {
  title?: string;
  imagesCount: number;
  thumbnailUrl?: string;
  onBack?: () => void;
  onCreate?: () => void;
}

export function FunnelCreativesHeader({
  title = "Creativos",
  imagesCount,
  thumbnailUrl,
  onBack,
  onCreate,
}: FunnelCreativesHeaderProps) {
  const { language } = useAuth();

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-4 min-w-0">
        <button
          type="button"
          onClick={onBack ?? (() => window.history.back())}
          className="text-gray-500 hover:text-gray-800 flex-shrink-0"
          aria-label="Volver"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>

        <div className="h-14 w-14 rounded-xl bg-white overflow-hidden border border-gray-200 flex items-center justify-center flex-shrink-0 p-1">
          {thumbnailUrl ? (
            <img src={thumbnailUrl} alt="" className="max-w-full max-h-full object-contain" />
          ) : (
            <div className="w-full h-full bg-gray-100 rounded-lg" />
          )}
        </div>

        <div className="min-w-0">
          <h1
            title={title}
            className="text-xl font-bold text-gray-900 truncate max-w-[500px]"
          >
            {title}
          </h1>
          <p className="text-gray-500 text-sm">
            {imagesCount} {dictionary["creatives"]?.[language as Language] || "creativos"}
          </p>
        </div>
      </div>

      <DefaultButton
        title={dictionary["create-new-ad-with-ai"]?.[language as Language] || "Crear nuevo Anuncio con IA"}
        onClick={onCreate ?? (() => console.log("crear nuevo anuncio con IA"))}
        icon={<Sparkles className="h-4 w-4" />}
        className="font-semibold flex-shrink-0"
      />
    </div>
  );
}


